import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {header} from "./header";
import {tagTypesView_template} from "../components/templates/tagTypesView_template";

declare var ko: any;
declare var page: any;

export class tagTypes_view extends vnModule_knockoutJS{

    protected viewForm: tagTypesView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return "tagTypes_view";
    }

    buildContent(): Array<Element>{

        this.viewForm = new tagTypesView_template("view_template", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Tag Type View");

        if (this.isBrand()) {
            this.viewForm.setBrandId(this.getBrandId());
        } else {
            this.viewForm.setBrandId(undefined);
        }

        return [this.viewForm.build()];
    }

    public fillPage(): void{

        this.getTagType();
    }

    protected getTagType(){

        this.loadingIn(this.viewForm.builtTemplate);

        let idTagType = this.getVnAppZone().getApp().params.idTagType;

        let usrReq_url: string = this.buildGetOneRequestUrl(idTagType);

        let usrReq_params: Array<Array<string>> = [];

        let vm = this.viewForm.getViewModelForRequest();

        usrReq_params.push(["data", ko.toJSON(vm)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj){
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.setTagType(responseParsed.data);
                obj.viewForm.setPermissions(responseParsed.data.permissions)
            });

            obj.loadingOut(obj.viewForm.builtTemplate);
        }
    }

    public setTagType(data): void{

        this.viewForm.setId(data.tagType.id);
        this.viewForm.setName(data.tagType.name);
        this.viewForm.setGroupings(data.groupings);
        this.viewForm.setSpecifications(data.tagType.fields);
        this.viewForm.setBrandOwner(data.tagType.brandOwner ? data.tagType.brandOwner : null);

        this.viewForm.setDatasetName(data.tagType.dataset ? data.tagType.dataset.name : '');

        if (typeof data.tagType.productSchemaTemplate !== 'undefined' && data.tagType.productSchemaTemplate !== null) {
            this.viewForm.setProductSchemaTemplateName(data.tagType.productSchemaTemplate.name);
            this.viewForm.setProductSchemaTemplate(data.tagType.productSchemaTemplate);
            this.viewForm.setProductSchemaTemplateId(data.tagType.productSchemaTemplate.id);
        }
    }


    protected edit(id){

        let url: string = this.buildEditRequestUrl(id);

        page.redirect(url);
    }

    protected cancel(){

        let url: string = this.buildCancelRequestUrl()

        page.redirect(url);
    }


    protected buildEditRequestUrl(id: number): string {

        let url = '/categorization/tag-types/edit/' + id;

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            url = '/brand/' + brandId +'/categorization/tag-types/edit/' + id;
        }

        return url;
    }


    protected buildGetOneRequestUrl(id: number): string {


        let url: string = '/api/tag/types/get/' + id;

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            url = '/api/brand/' + brandId + '/tag/types/get/' + id;
        }
        return url;
    }

    protected buildCancelRequestUrl(): string {

        let url = '/categorization/tag-types'

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            url = '/brand/'+ brandId +'/categorization/tag-types'
        }
        return url;
    }


    public isBrand(): boolean {

        let number = Number(this.getBrandId());
        return Number.isInteger(number);
    }

    public getBrandId(): number {

        return Number(this.getVnAppZone().app.params.idBrand);
    }
}



// WEBPACK FOOTER //
// ./js/modules/tagTypes_view.ts